import { isOfflineStatus } from '../../../../offline/domain/offlineOrder/offlineOrder.types';
import { getSuggestedGridHandler } from '../../product/grid/components/orderProductGrid/utils/suggestedGrid.utils';
import useHandleOrderProductPacks from '../../product/grid/components/packsMenu/hooks/useHandleOrderProductPacks';
import { useProductGridActions } from '../../product/grid/hooks/useProductGridActions';
import { UseAddOrderProductGridActionsParams } from '../addOrderProduct.types';

export const useAddOrderProductGridActions = ({
  orderId,
  orderStatus,
  availability,
  productColorId,
  deliveryWindow,
  grid,
  createOrderItems,
  selectedPacks,
  suggestedGrid,
  onApplyQuantities,
  onSelectPacks,
}: UseAddOrderProductGridActionsParams) => {
  const { updatePacks } = useHandleOrderProductPacks({
    orderId,
    availability,
    productColorId: productColorId || '',
    deliveryWindowId: deliveryWindow?.id,
  });

  const { handleSelectSuggestion, handleSelectPacks } = useProductGridActions({
    grid,
    availability,
    productColorId,
    deliveryWindowId: deliveryWindow?.id,
    orderId,
    onApplyQuantities,
    onSelectPacks,
  });

  const submitSelectedPacks = () =>
    updatePacks(selectedPacks.map((pack) => ({ id: pack.packId, quantity: pack.quantity || 1 })));

  const { showSuggestedGrid, suggestionAchieved } = getSuggestedGridHandler({
    grid,
    suggestedGrid,
    createOrderItems,
    orderStatus: isOfflineStatus(orderStatus) ? undefined : orderStatus,
  });

  return {
    showSuggestedGrid,
    suggestionAchieved,
    handleSelectSuggestion,
    handleSelectPacks,
    submitSelectedPacks,
  };
};
